<template>
	<div>
		<ScheduleBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>나의 중국 주소</h3>
			</div>
			<el-row >
				<el-col :xs="24" :sm="6" >
					<div class="item-name border-top-color">
						地址信息 (주소)
					</div>
				</el-col>
				<el-col :xs="24" :sm="15">
					<div class="item-content border-top-color">
						{{info.address}}
					</div>
				</el-col>
				<el-col :xs="24" :sm="3">
					<div class="item-button border-top-color">
						<el-button type="primary" plain round @click="copyText(info.address)">복사</el-button>
					</div>
				</el-col>
			
			</el-row>
			<el-row >
				<el-col :xs="24" :sm="6" >
					<div class="item-name border-center-color">
						详细地址 (상세주소)
					</div>
				</el-col>
				<el-col :xs="24" :sm="15">
					<div class="item-content border-center-color">
						{{info.detailed_address}} &nbsp;&nbsp;<span v-if="user_info.post_id">{{user_info.post_id}}</span><span v-else>사서함번호</span> <!--(로그인시 사서함번호 확인가능)-->
					</div>
				</el-col>
				<el-col :xs="24" :sm="3">
					<div class="item-button border-center-color">
						<el-button type="primary" plain round @click="copyText(info.detailed_address + (user_info.post_id ? ' ' + user_info.post_id : ''))">복사</el-button>
					</div>
				</el-col>
			</el-row>
			<el-row >
				<el-col :xs="24" :sm="6" >
					<div class="item-name border-center-color">
						邮编 (우편번호)
					</div>
				</el-col>
				<el-col :xs="24" :sm="15">
					<div class="item-content border-center-color">
						{{info.zip_code}} (타오바오는 우편번호 기재 불필요)
					</div>
				</el-col>
				<el-col :xs="24" :sm="3">
					<div class="item-button border-center-color">
						<el-button type="primary" plain round @click="copyText(info.zip_code)">복사</el-button>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :xs="24" :sm="6" >
					<div class="item-name border-center-color">
						收货人姓名 (수령인 이름)
					</div>
				</el-col>
				<el-col :xs="24" :sm="15">
					<div class="item-content border-center-color">
						K{{info.consignee_name}}
					</div>
				</el-col>
				<el-col :xs="24" :sm="3">
					<div class="item-button border-center-color">
						<el-button type="primary" plain round @click="copyText('K' + info.consignee_name)" >복사</el-button>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :xs="24" :sm="6" >
					<div class="item-name border-center-color">
						手机号码 (휴대폰번호)
					</div>
				</el-col>
				<el-col :xs="24" :sm="15">
					<div class="item-content border-center-color">
						{{info.mobile_phone}}
					</div>
				</el-col>
				<el-col :xs="24" :sm="3">
					<div class="item-button border-center-color">
						<el-button type="primary" plain round @click="copyText(info.mobile_phone)">복사</el-button>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :xs="24" :sm="6" >
					<div class="item-name border-center-color border-bottom-color">
						固定电话 (고정전화번호)
					</div>
				</el-col>
				<el-col :xs="24" :sm="15">
					<div class="item-content border-center-color border-bottom-color">
						타오바오, 1688 기재 불필요
					</div>
				</el-col>
				<el-col :xs="24" :sm="3">
					<div class="item-button border-center-color border-bottom-color" style="height: 60px;">
						
					</div>
				</el-col>
			</el-row>
			
			<div class="type-card">
				<h5>고로켓고 중국 웨이하이센터 소개</h5>
				
				<el-row>
					<el-col :xs="24" :sm="12">
						<img src="../../assets/list/address-img1.jpg" class="img-responsive img-bottom" loading="lazy" alt="웨이하이 센터">
					</el-col>
					<el-col :xs="24" :sm="12">
						<img src="../../assets/list/address-img2.jpg" class="img-responsive" loading="lazy" alt="웨이하이 센터">
					</el-col>
				</el-row>
					
				<p>고로켓고 웨이하이 센터는 넓은 공간과 총 60여 대의 CCTV 경비인력 상주로 <br class="hidden-xs">보안이 우수하며 회원님의 상품을 안전하게 배송합니다.</p>	

			</div>
			
			<article>
				<h5>중국주소 변경방법</h5>
				<div class="type-card">
					<h6>타오바오 주소변경</h6>
					<div class="img-box">
						<img src="../../assets/list/address-img3.png" class="img-responsive" loading="lazy" alt="타오바오 주소변경">
					</div>
					<div class="img-box">
						<img src="../../assets/list/address-img4.png" class="img-responsive" loading="lazy" alt="타오바오 주소변경">
					</div>
					<div class="img-box">
						<img src="../../assets/list/address-img5.png" class="img-responsive" loading="lazy" alt="타오바오 주소변경">
					</div>
					<div class="img-box">
						<img src="../../assets/list/address-img6.png" class="img-responsive" loading="lazy" alt="타오바오 주소변경">
					</div>
					<a href="https://world.taobao.com/" target="_blank" class="link-btn">타오바오 바로가기</a>
				</div>
			</article>
			
			<article>
				<div class="type-card">
					<h6>1688 주소변경</h6>
					<div class="img-box">
						<img src="../../assets/list/address-img7.png" class="img-responsive" loading="lazy" alt="1688 주소변경">
					</div>
					<div class="img-box">
						<img src="../../assets/list/address-img8.png" class="img-responsive" loading="lazy" alt="1688 주소변경">
					</div>
					<div class="img-box">
						<img src="../../assets/list/address-img9.png" class="img-responsive" loading="lazy" alt="1688 주소변경">
					</div>
					<a href="https://alibaba.com.cn/" target="_blank" class="link-btn">1688 바로가기</a>
				</div>		
			</article>
			
		
			
		</div>	
	</div>
</template>

<script>
	import ScheduleBanner from '../../components/ScheduleBanner.vue'
	import request from '@/utils/request'
	export default {
		components: {
			ScheduleBanner
		},
		data() {
			return{ 
				info:"",
				user_info:{},
			}
		},
		created() {
			this.getAddress()
			this.getUserInfo()
		},
		methods: {
			getUserInfo(){
				request.post('/User/getUserInfo',{}
				).then(res => {
					if(res.code ==1){
						console.log(res.data,"2323")
						this.user_info= res.data
					}		
				});
			},
			getAddress(){
				request.post('/Index/getAddress',
					{}
				).then(res => {
					console.log(res,"2323")
					if(res.code ==1){
						this.info = res.data
					}
						
				});
			},
			async copyText(text) {
				try {
				  if (navigator.clipboard) {
					await navigator.clipboard.writeText(text);
				  } else {
					// 降级方案
					const textarea = document.createElement("textarea");
					textarea.value = text;
					document.body.appendChild(textarea);
					textarea.select();
					document.execCommand("copy");
					document.body.removeChild(textarea);
				  }
				  this.$message.success("Ctrl+V로 붙여넣기 하시면 됩니다."); // 使用 ElementUI 提示
				} catch (err) {
				  console.error("复制失败:", err);
				  this.$message.error("복사 error");
				}
			}
		}
	
	}
</script>

<style scoped>
	.title-wrap {
	    text-align: center;
	    color: var(--frontground-color);
	    margin-bottom: 40px;
	}
	.title-wrap h3 {
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin-bottom: 0;
	}
	.item-name{	
	    padding: 19px 10px 18px;
		background-color: #f5f8fd;
		text-align: center;
		color: var(--background-color);
	}
	.item-content{
		padding: 19px 10px 18px;
		text-align: center;
	}
	.item-button{	
		display: flex;
		justify-content: center;
		padding-top: 10px;
		
	}
	.border-top-color{
		border-top: 1px solid #333;
	}
	.border-center-color{
		border-top: 1px solid var(--border-color);
	}
	.border-bottom-color{
		border-bottom: 1px solid var(--border-color);
	}
	.type-card {
		margin-top: 50px;
	    padding: 41px 49px 44px;
	    background-color: #fff;
		border-radius: 30px;
		border: 1px solid var(--border-color);
		overflow: hidden;
	}
	.type-card h5 {
	    margin-bottom: 41px;
		font-size: 30px;
		font-weight: bold;
		color: var(--background-color);
	}
	.type-card h6{
		color: var(--background-color);
	}
	article h5{
		font-size: 30px;
	}
	.type-card .img-box {
	    display: flex;
	    justify-content: space-between;
		margin-bottom: 20px;
	}
	.img-responsive{
	    display: block;
	    max-width: 100%;
	    height: auto;
	}
	.type-card p {
	    font-size: 17px;
	    line-height: 31px;
	    text-align: center;
	    color: black;
	    margin-top: 35px;
	    margin-bottom: 0;
	}
	article{
		margin-top:40px;
	}

	article h6 {
	    font-size: 24px;
	    font-weight: bold;
	    margin-bottom: 21px;
	}
	.link-btn {
	    display: flex;
	    width: 211px;
	    height: 64px;
	    justify-content: center;
	    align-items: center;
	    background: #FF5C00;
	    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
	    border-radius: 36px;
	    color: #fff;
	    font-size: 20px;
	    font-weight: bold;
	    margin: 20px auto 0;
	    border: 0;
		text-decoration: none;
	}
	
	
	.el-row{
		margin-bottom: 0;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:0 10px 40px;
		}
		.title-wrap{
			 margin-top: 40px;
		}
		.title-wrap h3 {
			font-size: 30px;
		}
		.item-button{
			border-top: none;
			padding-top: 0;
			padding-bottom: 20px;
		}
		.border-bottom-color{
			border-bottom: none;
		}
		.type-card{
			margin-top: 0;
			padding:20px;
		}
		.type-card h5{
			font-size: 20px;
		}
		.img-bottom{
			margin-bottom: 20px;
		}
		article h5 {
		    font-size: 24px;
		    text-align: center;
			margin-bottom: 20px;
		}

		
		.hidden-xs {
			display: none !important;
		}
	}
	
	
</style>